import img_visa from '@icoach/assets/img/visa.png';
import img_mastercard from '@icoach/assets/img/mastercard.png';
import img_jcb from '@icoach/assets/img/jcb.png';
import img_bank from '@icoach/assets/img/bank.png';
import img_cash from '@icoach/assets/img/cash.png';

export const MEMBER_DETAIL_TABS_MAP = {
    INFO: 'info',
    PAYMENT: 'payment',
    INVOICE: 'invoice',
    HC_OVERVIEW: 'hc-overview',
    HC_BILLING: 'hc-billing',
    RB_DOCUMENT: 'document',
    RB_BILLING: 'billing',
    UNCHECKOUT: 'uncheckout',
    ORDER_RECORD: 'order-record',
    GIFT_CLAIM: 'gift-claim',
    SFB_DOCUMENT: 'sfb-document',
    SFB_BILLING: 'sfb-billing',
};

export const paymentTypeImageMap = {
    1: {
        1: img_visa,
        2: img_mastercard,
        3: img_jcb,
    },
    2: img_bank,
    3: img_cash,
}
